// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectedItem_wrapper__8EUrA"};